import { c as e } from "./ghl-ui.es669.js";
import a from "./ghl-ui.es1193.js";
const {
  cubicBezierEaseInOut: t
} = a;
function $({
  duration: i = ".2s",
  delay: n = ".1s"
} = {}) {
  return [e("&.fade-in-width-expand-transition-leave-from, &.fade-in-width-expand-transition-enter-to", {
    opacity: 1
  }), e("&.fade-in-width-expand-transition-leave-to, &.fade-in-width-expand-transition-enter-from", `
 opacity: 0!important;
 margin-left: 0!important;
 margin-right: 0!important;
 `), e("&.fade-in-width-expand-transition-leave-active", `
 overflow: hidden;
 transition:
 opacity ${i} ${t},
 max-width ${i} ${t} ${n},
 margin-left ${i} ${t} ${n},
 margin-right ${i} ${t} ${n};
 `), e("&.fade-in-width-expand-transition-enter-active", `
 overflow: hidden;
 transition:
 opacity ${i} ${t} ${n},
 max-width ${i} ${t},
 margin-left ${i} ${t},
 margin-right ${i} ${t};
 `)];
}
export {
  $ as fadeInWidthExpandTransition
};
